import React from 'react';
import {
  LottieView,
  PanelContainer,
  openURL,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {LOADER_ANIMATION} from 'assets/LottieAnimations';
import OffersErrorDisplay from 'components/Offers/ErrorDisplay';
import {
  ReservationDate,
  ReservationState,
  ReservationStatus,
} from 'models/Reservations';
import {View, Text} from 'native-base';
import envData from 'env.json';
import {useTheme} from 'styled-components/native';
import ReservationsEmptyDisplay from '../ReservationsEmptyDisplay/ReservationsEmptyDisplay';

const {API_URL} = envData;

export interface ReservationsModuleProps {
  activeTab?: ReservationState | ReservationStatus;
  isLoading: boolean;
  hasFailed: boolean;
  reservations: ReservationDate[] | undefined;
  getReservationCard: (reservation: ReservationDate) => JSX.Element | null;
  isHomeScreen: boolean;
}

const ReservationsModule: React.FC<ReservationsModuleProps> = props => {
  const {
    activeTab,
    isLoading,
    hasFailed,
    reservations,
    isHomeScreen,
    getReservationCard,
  } = props;
  const isDesktop = useIsDesktop();
  const theme = useTheme();
  const {tuna} = theme.colors as any;

  const reservationsDisplayed = reservations?.map(reservation =>
    getReservationCard(reservation)
  );

  return reservations?.length === 0 ? (
    <ReservationsEmptyDisplay activeTab={activeTab} />
  ) : (
    <PanelContainer
      panelTitle={
        activeTab === ReservationState.FUTURE ||
        activeTab === ReservationState.CURRENT ||
        isHomeScreen
          ? 'Current Reservations'
          : activeTab === ReservationState.PAST
            ? 'Past Reservations'
            : 'Cancelled Reservations'
      }
      icon="calendar-alt"
      primaryCTA={{
        label: isHomeScreen ? 'See all reservations' : 'Find a Reservation',
        onPress: () => {
          isHomeScreen
            ? openURL('/rewards/stays')
            : openURL(`${API_URL}/book/my-reservation`);
        },
      }}
      contentMaxWidth="100%">
      <Text
        fontFamily="body"
        fontSize="16px"
        lineHeight="25px"
        color={tuna}
        maxWidth="100%">
        {activeTab === ReservationState.FUTURE || isHomeScreen
          ? 'View and manage your upcoming stays at Caesars Entertainment properties.'
          : activeTab === ReservationState.PAST
            ? 'View your past stays at Caesars Entertainment properties, up to three (3) months in the past.'
            : 'View your cancelled stays at Caesars Entertainment properties, up to three (3) months in the past.'}
      </Text>

      <View pt="48px">
        {isLoading ? (
          <LottieView
            source={LOADER_ANIMATION}
            loop
            autoPlay
            style={{
              width: isDesktop ? 550 : '100%',
              height: isDesktop ? 550 : undefined,
            }}
          />
        ) : hasFailed ? (
          <OffersErrorDisplay />
        ) : (
          <>{reservationsDisplayed}</>
        )}
      </View>
    </PanelContainer>
  );
};

export default ReservationsModule;
